import { colorYiq } from "@/projectRoot/src/utils/handlers/miscHandler";

interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  fill?: boolean;
}

export const GridFourColumn = ({
  width = 20,
  height = 20,
  hexColor = "#ffffff",
  fill = false
}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.333333" y="0.333333" width="8" height="8.00333" rx="2.33333" fill={hexColor} stroke={fill ? hexColor : colorYiq(hexColor)} strokeWidth="0.666667"/>
      <rect x="11.6663" y="0.333333" width="8" height="8.00333" rx="2.33333" fill={hexColor} stroke={fill ? hexColor : colorYiq(hexColor)} strokeWidth="0.666667"/>
      <rect x="0.333333" y="11.6698" width="8" height="8.00333" rx="2.33333" fill={hexColor} stroke={fill ? hexColor : colorYiq(hexColor)} strokeWidth="0.666667"/>
      <rect x="11.6663" y="11.6698" width="8" height="8.00333" rx="2.33333" fill={hexColor} stroke={fill ? hexColor : colorYiq(hexColor)} strokeWidth="0.666667"/>
    </svg>
  );
};

export default GridFourColumn;
